import { render, staticRenderFns } from "./page-iframe.vue?vue&type=template&id=de3a593a&lang=pug&"
import script from "./page-iframe.vue?vue&type=script&lang=js&"
export * from "./page-iframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports